module.exports = __webpack_public_path__ + "static/media/bill_alert.6f446c09.svg";